export enum CarriersSort {
    CODE_ASC = 'code',
    NAME_ASC = 'name',
    BUSINESS_NAME_ASC = 'businessName',
    TAGS_ASC = 'tags',
    CODE_DESC = '-code',
    NAME_DESC = '-name',
    BUSINESS_NAME = '-businessName',
    TAGS_DESC = '-tags',
}
